import React, { Component } from 'react';
import { Box, Stack, Skeleton, Button, Typography } from '@mui/material';
import { faChevronDoubleDown, faChevronDoubleUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DetailsList from './DetailsList';

class DetailsContent extends Component {
  state = {
    verified: { items: [], indices: [] },
    nonVerifiable: { items: [], indices: [] },
  };

  componentDidMount() {
    const { verified, nonVerifiable } = this.divideUpChecklistItems(this.props.items);
    this.setState({ verified, nonVerifiable });
  }

  expandAll = () => {
    this.props.setExpansionBulk(this.props.items, true);
  };

  collapseAll = () => {
    this.props.setExpansionBulk(this.props.items, false);
  };

  divideUpChecklistItems = (items) => {
    const verified = { items: [], indices: [] };
    const nonVerifiable = { items: [], indices: [] };
    items.forEach((item, index) => {
      const target = item.itemBoxHideInd ? nonVerifiable : verified;
      target.items.push(item);
      target.indices.push(index);
    });
    return { verified, nonVerifiable };
  };

  render() {
    const { verified, nonVerifiable } = this.state;

    const expandedCount =
      this.props.items?.filter((item) => this.props.itemsExpansionStatus[item.itemTimeCode])
        .length || 0;
    const isDisableExpandAll = expandedCount === this.props.items?.length;
    const isDisableCollapseAll = expandedCount === 0;
    const isReady = Object.keys(this.props.itemsExpansionStatus).length > 0;

    return (
      <Box>
        <Stack
          sx={{ width: '100%', mb: 2 }}
          direction={{ xs: 'col', sm: 'row' }}
          alignItems={'center'}
          justifyContent={'flex-end'}
        >
          <Button
            id="checklist__button_expandAll"
            onClick={this.expandAll}
            variant="outlined"
            className="myOdu__button secondary checklistButton"
            size="small"
            disabled={isDisableExpandAll}
            startIcon={
              <FontAwesomeIcon
                fixedWidth
                icon={faChevronDoubleDown}
                size="sm"
                style={{ fontSize: '.8rem' }}
              />
            }
          >
            Expand All
          </Button>
          <Button
            id="checklist__button_collapseAll"
            onClick={this.collapseAll}
            variant="outlined"
            className="myOdu__button secondary checklistButton"
            size="small"
            disabled={isDisableCollapseAll}
            startIcon={
              <FontAwesomeIcon
                fixedWidth
                icon={faChevronDoubleUp}
                size="sm"
                style={{ fontSize: '.8rem' }}
              />
            }
          >
            Collapse All
          </Button>
        </Stack>
        {isReady && (
          <>
            {verified.items.length > 0 && (
              <Box>
                <Typography component="h3" id="checklists__h3_systemVerifiedItems">
                  System Verified Items
                </Typography>
                <DetailsList
                  items={verified.items}
                  isLoading={this.props.isLoading}
                  checklistTitle={this.props.checklistTitle}
                  toggleItemExpansionStatus={this.props.toggleItemExpansionStatus}
                  itemsExpansionStatus={this.props.itemsExpansionStatus}
                  tabSelected={this.props.tabSelected}
                />
              </Box>
            )}
            {nonVerifiable.items.length > 0 && (
              <Box sx={{ mt: verified.items.length > 0 ? 3 : 0 }}>
                <Typography component="h3" id="checklists__h3_nonVerifiableItems">
                  Unverifiable Items
                </Typography>
                <Box className="nonVerifiableCallout">
                  <Typography>
                    <strong>The items below will not display a checkmark upon completion.</strong>{' '}
                    The myODU portal can&apos;t automatically verify certain tasks, including those
                    involving personal interactions.
                  </Typography>
                </Box>
                <DetailsList
                  items={nonVerifiable.items}
                  isLoading={this.props.isLoading}
                  checklistTitle={this.props.checklistTitle}
                  toggleItemExpansionStatus={this.props.toggleItemExpansionStatus}
                  itemsExpansionStatus={this.props.itemsExpansionStatus}
                  tabSelected={this.props.tabSelected}
                  isNonVerifiable
                />
              </Box>
            )}
          </>
        )}
        {!isReady && <Skeleton variant="rectangular" />}
      </Box>
    );
  }
}

export default DetailsContent;
